import Hotjar from '@hotjar/browser';

const handleConfigsAccordingEnvironment = () => {
  let siteId;
  let hotjarVersion;

  const url = window.location.href.toString();

  if (
    url.startsWith('https://podemorar') ||
    url.startsWith('https://www.podemorar')
  ) {
    siteId = 3632810;
    hotjarVersion = 6;
  } else {
    siteId = 3632614;
    hotjarVersion = 6;
  }

  return { siteId, hotjarVersion };
};

const initHotjarWithConfigs = () => {
  const { siteId, hotjarVersion } = handleConfigsAccordingEnvironment();

  Hotjar.init(siteId, hotjarVersion);
};
export default initHotjarWithConfigs;
